import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";

import { FormsModule } from "@angular/forms";
import { ReportingAllbrokersComponent } from "./reporting-allbrokers/reporting-allbrokers.component";
import { ReportingBrokerComponent } from "./reporting-broker/reporting-broker.component";
import { ReportingAnalystComponent } from "./reporting-analyst/reporting-analyst.component";
import { ReportingSectorComponent } from "./reporting-sector/reporting-sector.component";
import { GlobalReportingFiltersComponent } from "./global-reporting-filters/global-reporting-filters.component";
import { AntGridCustomModule } from "./../ant-grid-custom/ant-grid-custom-module";
import { ReportingGridWrapperComponent } from "./reporting-grid-wrapper/reporting-grid-wrapper.component";
import { SharedModule } from "./../shared/shared.module";
import { IconsModule } from "@va/core-library/icons";
import { ReportingModelLibraryComponent } from "./reporting-model-library/reporting-model-library.component";
import { ReportingIndustryComponent } from "./reporting-industry/reporting-industry.component";
import { ReportingAllcompaniesComponent } from "./reporting-allcompanies/reporting-allcompanies.component";
import { ReportingRouteGuardService } from "./reporting-route-guard.service";
import { CustomGridModule } from "@va/core-library/custom-grid";
import { CustomSkeletonModule } from "@va/core-library/custom-skeleton";

// ant modules
import { NzTableModule } from "ng-zorro-antd/table";
import { NzSwitchModule } from "ng-zorro-antd/switch";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";

const reportingRoutes: Routes = [
  {
    path: "allbrokers",
    component: ReportingAllbrokersComponent,
    data: {
      title: "All Brokers Page",
    },
  },
  {
    path: "broker/:brokerName",
    component: ReportingBrokerComponent,
    data: {
      title: "Broker",
    },
    canActivate: [ReportingRouteGuardService],
  },
  {
    path: "analyst/:analystId",
    component: ReportingAnalystComponent,
    data: {
      title: "Analyst Page",
    },
  },
  {
    path: "sector/:sectorName",
    component: ReportingSectorComponent,
    data: {
      title: "Sector Page",
    },
  },
  {
    path: "models",
    component: ReportingModelLibraryComponent,
    data: {
      title: "Model Library",
    },
  },
  {
    path: "industry/:sectorName/:industryName",
    component: ReportingIndustryComponent,
    data: {
      title: "Industry Page",
    },
  },
  {
    path: "allcompany",
    component: ReportingAllcompaniesComponent,
    data: {
      title: "All Companies Page",
    },
  },
  {
    path: "allcompany/:dataCovTypeId",
    component: ReportingAllcompaniesComponent,
    data: {
      title: "All Companies Page",
    },
  },
  {
    path: "allcompany/:dataCovTypeId/:search",
    component: ReportingAllcompaniesComponent,
    data: {
      title: "All Companies Page",
    },
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(reportingRoutes)],
  exports: [RouterModule],
  declarations: [],
})
export class ReportingPagesRoutingModule {}

@NgModule({
  declarations: [
    ReportingGridWrapperComponent,
    ReportingAllbrokersComponent,
    ReportingBrokerComponent,
    ReportingAnalystComponent,
    ReportingSectorComponent,
    GlobalReportingFiltersComponent,
    ReportingModelLibraryComponent,
    ReportingIndustryComponent,
    ReportingAllcompaniesComponent,
  ],
  imports: [
    CommonModule,
    ReportingPagesRoutingModule,
    NzTableModule,
    NzSwitchModule,
    NzModalModule,
    NzInputModule,
    NzSkeletonModule,
    AntGridCustomModule,
    SharedModule,
    FormsModule,
    IconsModule,
    CustomGridModule,
    CustomSkeletonModule,
  ],
})
export class ReportingPagesModule {}
